export const formatNumber = (number: number | string): string | null => {
  if (typeof number !== 'undefined' && number !== null) {
    return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
  }
  return null;
};

type GradeFormatter = {
  grade: string | number;
  ratingPrecision?: 1 | 2;
};

export function gradeFormatter({ grade, ratingPrecision = 1 }: GradeFormatter): string | null {
  if (grade !== undefined && grade !== null && grade !== '') {
    if (grade === 0) {
      return '0';
    }
    if (grade.toString().length === 1) {
      return `${grade}.0`;
    }
    if (grade.toString().length >= 3) {
      const trimGrade = (Math.round(+grade * 100) / 100).toFixed(ratingPrecision).toString();
      if (trimGrade.length === 1) {
        return `${trimGrade}.0`;
      }
      return trimGrade;
    }
    return grade.toString();
  }
  // eslint-disable-next-line no-console
  console.log('Grade not provided');
  return null;
}
